export type ModuleName = "notifications"
export const MODULE_NAME: ModuleName = "notifications"
